import React from "react";
import Modal from "../../../../shared/components/Modal/Modal";
import "./TestSyllabusModal.css";
import images from "../../../../utilities/images/images";

const TestSyllabusModal = ({ onClose }) => {
  return (
    <Modal isOpen={true} onClose={onClose} width="440px">
     <div className="syllabus_modal_content" >
  <div className="syllabus_header">
  <h2>Test Syllabus</h2>
  <p>SRMJEE Full Test</p>
</div>
  <div className="syllabus_subject_container">
    <div className="syllabus_subject_header">
      <div className="syllabus_subject_left">
        <img src={images.physics_icon} className="syllabus_subject_icon" />
        <span className="syllabus_subject_name">Physics</span>
      </div>

      <div className="syllabus_topic_count">4 topics</div>
    </div>

    <ul className="syllabus_topic_list">
      <li>Rotational Motion</li>
      <li>Optics</li>
      <li>Thermodynamics</li>
      <li>Simple Harmonic Motion</li>
    </ul>
  </div>
  <div className="coverage_summary_content">
<div className="coverage_summary_header">Coverage Summary</div>

  <div className="coverage_summary">
    <div>Total Subjects: <strong>1</strong></div>
    <div>Total Topics: <strong>4</strong></div>
  </div>
  </div>

</div>

    </Modal>
  );
};

export default TestSyllabusModal;
